
let prices,bold;

function storeDefaultPrices(){
  console.log('variant-change');
  prices = document.querySelectorAll('.bold_custom_option_price_display');
  console.log(prices);
  prices.forEach((price)=>{
    price.setAttribute('data-price',price.textContent.replace(/[^0-9\.]/g,''));
  })
  showAddonCharge();
}

function showAddonCharge(){
  let addon = document.querySelector('.bold_option_total div span');
  prices.forEach((price)=>{
    price.textContent = (parseFloat(price.getAttribute('data-price')) + (addon ? parseFloat(addon.textContent.replace(/[^0-9\.]/g,'')) : 0)).toLocaleString(`${Shopify.locale}-${Shopify.country}`, { style: 'currency', currency: Shopify.currency.active });
  })
}

document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {
    bold = document.querySelector('.bold_option_set');
    storeDefaultPrices();
    bold.addEventListener('change',(event)=>{
      console.log('Change');
      setTimeout(showAddonCharge,500);
    })
  })
})

  window.addEventListener('bold-variant-change',()=>{
    setTimeout(storeDefaultPrices,350);
  });